import axios from 'axios';
import logger from './../Tools/Log'
// import Config from 'Config';


const axiosInstance1 = axios.create({
    baseURL : 'http://webapi.bitkala.ir/',
    timeout : 50000
});

// const axiosInstance1 = axios.create({
//     baseURL: 'http://localhost/EcommerceApi/',
//     timeout: 50000000
// });

// const axiosInstance1 = axios.create({
//     baseURL: 'http://localhost:3094/',
//     timeout: 50000000
// });

// const axiosInstance1 = axios.create({
//     baseURL : Config.serverUrl,
//     timeout : 50000000
// });

//in 2 ta paeen middleware hastand ke ghable eral ya ghable daryaft mitavan taghirati dad
axiosInstance1.interceptors.request.use(function (config) {
    logger('Axios>>Requset@>>Success>>', config);
    return config;
}, function (err) {
    logger('Axios>>Requset@>>Error>>', err);
    return Promise.reject(err)
})

axiosInstance1.interceptors.response.use(function (config) {
    logger('Axios>>Response$>>Success>>', config);
    return config;
}, function (err) {
    logger('Axios>>Response$>>Error>>', err);
    logger('Axios>>Response$>>Error>>url>>', err.response.config.url);
    if (err.response.status === 401 && err.response.config.url !== 'api/accounts/user') {
        window.location.href = window.location.origin + '/login'
    }
    console.log(err.response);
    return Promise.reject(err)
})

export default axiosInstance1;